const state = {
  rewards: []
}

const getters = {
  rewards: state => state.rewards
}

const actions = {
  setRewards: ({ commit }, data) => { commit('setRewards', data) },
  updateReward: ({ commit }, data) => { commit('updateReward', data) },
  addReward: ({ commit }, data) => { commit('addReward', data) }
}

const mutations = {
  setRewards(state, data) {
    state.rewards = data
  },
  updateReward(state, data) {
    state.rewards = state.rewards.map(o => {
      if (o._id === data._id) return data
      return o
    })
  },
  addReward(state, reward) {
    state.rewards.unshift(reward)
  }
}

export default { state, getters, actions, mutations }